import axiosInstance from '@/core/api'
import {
	CreateRankRequest,
	CreateRankResponse,
	GetRankByIdResponse,
	GetRankNamesResponse,
	GetRankRequest,
	GetRankResponse,
	UpdateRankRequest,
	UpdateRankResponse,
	UpdateRankUpRewardsRequest,
	UpdateRankUpRewardsResponse,
} from '../../type'

export const getRankList = async (
	payload: GetRankRequest,
): Promise<GetRankResponse> => {
	const response = await axiosInstance.get<GetRankResponse>(
		`/admin/operators/ranks`,
		{
			params: payload,
		},
	)
	return response.data
}

export const getRankById = async (id: string): Promise<GetRankByIdResponse> => {
	const response = await axiosInstance.get<GetRankByIdResponse>(
		`/admin/operators/ranks/${id}`,
	)
	return response.data
}

export const createRank = async (
	payload: CreateRankRequest,
): Promise<CreateRankResponse> => {
	const response = await axiosInstance.post<CreateRankResponse>(
		`/admin/operators/ranks`,
		payload,
	)
	return response.data
}

export const updateRank = async (
	id: string,
	payload: UpdateRankRequest,
): Promise<UpdateRankResponse> => {
	const response = await axiosInstance.patch<UpdateRankResponse>(
		`/admin/operators/ranks/${id}`,
		payload,
	)
	return response.data
}

export const deleteRank = async (id: string): Promise<void> => {
	const response = await axiosInstance.delete<void>(
		`/admin/operators/ranks/${id}`,
	)
	return response.data
}

export const getRankNames = async (): Promise<GetRankNamesResponse> => {
	const response = await axiosInstance.get<GetRankNamesResponse>(
		`/admin/operators/ranks/names`,
	)
	return response.data
}

export const updateRankUpRewards = async (
	id: string,
	payload: UpdateRankUpRewardsRequest,
): Promise<UpdateRankUpRewardsResponse> => {
	const response = await axiosInstance.put<UpdateRankUpRewardsResponse>(
		`/admin/operators/ranks/${id}/rank-up-rewards`,
		payload,
	)
	return response.data
}
